import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M20 8l-8 5-8-5v10h16zm0-2H4l8 4.99z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 20h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2zM20 6l-8 4.99L4 6h16zM4 8l8 5 8-5v10H4V8z"
})), 'EmailTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/EmailTwoTone.js
// module id = 3327
// module chunks = 2